export const timeMap = {
    1: "09:00-10:00",
    2: "12:00-13:00",
    3: "19:00-20:00",
}

export const standardMap = {
    30: "30元/人",
    50: "50元/人",
    100: "100元/人",
}

export const locationMap = {
    1: "7层东侧茶水间",
    2: "8层西侧吧台",
    3: "9层东侧吧台",
    4: "10层西侧吧台",
    5: "11层东侧吧台",
    6: "东升大厦",
}